'use strict';
function ActualFlare(options) {

    var self = this;

    //var apiUrl = apiUrl;
    //var apiUrl = "http://localhost:8000";
    var apiUrl = (options && options.apiUrl) || "https://stagingapi.salesflare.com/";

    var pageStart = new Date(); // get the start time when the user logged in
    var trackingToken = (options && options.trackingToken) || undefined;
    var pageTitle;
    var header;

    var deviceId;

    var trackingDomains = ['llink.to', 'forward.llink.to', 'tracqid.com', 'trakcid.com', 'trakidt.com', 'trakitd.com', 'trakqid.com', 'trakqit.com', 'traqcid.com', 'traqcit.com', 'traqkid.com', 'traqkit.com', 'traqqid.com'];

    // external parameter library
    ActualFlare.vars = setVars();

    function setVars() {

        var vars = [];
        var hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }

        return vars;
    };

    // code from https://github.com/Financial-Times/polyfill-service/tree/master/packages/polyfill-library/polyfills/navigator/sendBeacon
    if (!('navigator' in this)) this.navigator = {};
    if (!('sendBeacon' in navigator)) {
        this.navigator.sendBeacon = function sendBeacon(url, data) {
            var xhr = ('XMLHttpRequest' in window) ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open('POST', url, false);
            xhr.setRequestHeader('Accept', '*/*');
            if (typeof data === 'string') {
                xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            } else if (Object.prototype.toString.call(data) === '[object Blob]') {
                if (data.type) {
                    xhr.setRequestHeader('Content-Type', data.type);
                }
            }
            xhr.send(data);
            return true;
        };
    }

    function executeHTTPRequest(options, callback) {

        var request = new XMLHttpRequest();

        if (callback) {
            request.onreadystatechange = function () {

                if (request.readyState === 4) {
                    if (request.status === 200) {
                        var response;

                        if (request.response) {
                            try {
                                response = JSON.parse(request.response);
                            } catch (e) {
                                response = request.response;
                            }
                        }
                        else {
                            response = {};
                        }

                        return callback(null, {
                            body: response,
                            status: request.status
                        });
                    }

                    var error = new Error('HTTP request failed');
                    error.data = request;

                    return callback(error)
                }
            };
        }

        request.open(options.method, options.url, options.async !== false);

        if (options.headers) {
            for (var key in options.headers) {
                if (options.headers.hasOwnProperty(key)) {
                    request.setRequestHeader(key, options.headers[key]);
                }
            }
        }

        if (options.body) {
            request.send(JSON.stringify(options.body));
        }
        else {
            request.send();
        }
    }

    function init(callback) {

        return getTokenFromVars(function () {

            if (!trackingToken) {
                window.location.href = sanitizeURL(ActualFlare.vars.u);
                return callback();
            }

            header = {
                "Authorization": "Bearer " + trackingToken
            };

            setDeviceId();

            if (deviceId === undefined || deviceId === null) {
                return executeHTTPRequest({
                    method: 'POST',
                    url: apiUrl + 'devices',
                    headers: header,
                    body: {}
                }, function (err, response) {

                    if (err) {
                        return callback(err);
                    }

                    deviceId = response.body.id;

                    localStorage.setItem('sf_' + trackingToken, deviceId);
                    
                    return callback();
                })
            }

            return callback();
        });
    }

    function setDeviceId() {
        var urlDeviceId = ActualFlare.vars['_sfd'] ? parseInt(ActualFlare.vars['_sfd'], 36) : null;
        urlDeviceId = isNaN(urlDeviceId) ? null : urlDeviceId;
    
        var localStorageDeviceId = parseInt(localStorage.getItem('sf_' + trackingToken));
        localStorageDeviceId = isNaN(localStorageDeviceId) ? null : localStorageDeviceId;
    
        if (urlDeviceId && urlDeviceId !== localStorageDeviceId) {
            localStorage.setItem('sf_' + trackingToken, urlDeviceId);
        }
    
        deviceId = urlDeviceId || localStorageDeviceId;
    }


    function setServerSideCookie(deviceId, token) {
        // Get the tracking domain from the current URL
        var trackingDomain = '';
        
        try {
            var url = new URL(window.location.href);
            trackingDomain = url.origin;
        } catch (e) {
            // If URL parsing fails, try manual parsing
            var currentUrl = window.location.href;
            var urlParts = currentUrl.split('/');
            if (urlParts.length >= 3) {
                trackingDomain = urlParts[0] + '//' + urlParts[2];
            }
        }

        // Check if the hostname contains any of our tracking domains
        var isTrackingDomain = false;
        for (var i = 0; i < trackingDomains.length; i++) {
            if (url.hostname.indexOf(trackingDomains[i]) !== -1) {
                isTrackingDomain = true;
                break;
            }
        }

        if (trackingDomain && isTrackingDomain) {
            // Use sendBeacon to set the cookie
            navigator.sendBeacon(trackingDomain + '/set-cookie?d=' + deviceId + '&t=' + token);
        }
    }

    this.track = function track(_trackingToken) {

        trackingToken = _trackingToken;
        pageTitle = document.title;

        return init(function (err) {

            if (err) {
                throw err;
            }

            ifvisible.setIdleDuration(30);

            ifvisible.on("idle", function () {

                self.trackPage();
            });

            ifvisible.on("wakeup", function () {

                pageStart = new Date();
            });
        });
    };

    this.identifyById = function identifyById(id, callback) {

        return init(function (err) {

            if (err) {
                throw err;
            }

            return executeHTTPRequest({
                method: 'PUT',
                url: apiUrl + 'devices/' + deviceId,
                headers: header,
                body: { contact: id }
            }, callback);
        });
    };

    this.trackPage = function trackPage() {

        var pageEnd = new Date();
        var duration = pageEnd - pageStart;

        var interactionGroup = {
            device: "" + deviceId,
            type: 'webpage'
        };

        if (document.referrer !== "") {
            interactionGroup.referrer = document.referrer;
        }

        if (ActualFlare.vars.e !== undefined) {
            interactionGroup.email = "" + ActualFlare.vars.e;
        }

        var currentPageTitle = document.title ? document.title : pageTitle;

        var interaction = {
            interactiongroup: interactionGroup,
            url: window.location.href,
            title: currentPageTitle,
            duration: duration
        };

        navigator.sendBeacon(apiUrl + 'interactions/webpage?access_token=' + trackingToken, JSON.stringify(interaction));
    };

    this.forward = function forward() {

        try {
            return init(function (err) {

                if (err) {
                    throw err;
                }

                // Set server-side cookie
                setServerSideCookie(deviceId, trackingToken);

                return identifyFromUrl(function () {

                    // future improvement: do not create interaction group client side (rely on server magic)
                    var interactionGroup = {
                        device: "" + deviceId,
                        type: "forward"
                    };

                    if (document.referrer !== "") {
                        interactionGroup.referrer = document.referrer;
                    }

                    // give email id to forward interaction
                    if (ActualFlare.vars.e !== undefined) {
                        interactionGroup.email = "" + ActualFlare.vars.e;
                    }

                    var interaction = {
                        interactiongroup: interactionGroup,
                        url: decode(ActualFlare.vars.u)
                    };

                    return executeHTTPRequest({
                        method: 'POST',
                        url: apiUrl + 'interactions/forward?instant=true',
                        headers: header,
                        body: interaction
                    }, function () {

                        window.location.href = sanitizeURL(ActualFlare.vars.u);
                    });
                });
            });
        }
        catch (err) {
            window.location.href = sanitizeURL(ActualFlare.vars.u);
        }
    };

    function getTokenFromVars(callback) {

        if (trackingToken !== undefined) {
            return callback();
        }

        if (ActualFlare.vars.t !== undefined) {
            trackingToken = ActualFlare.vars.t;

            return callback();
        }
        else if (ActualFlare.vars.e !== undefined) {
            return executeHTTPRequest({
                method: 'GET',
                url: apiUrl + 'token?email=' + encodeURIComponent(ActualFlare.vars.e),
                headers: header
            }, function (err, response) {

                if (err) {
                    return callback();
                }

                if (response && response.body && response.body.tracking_token) {
                    trackingToken = response.body.tracking_token;
                }

                return callback();
            });
        }
        else if (ActualFlare.vars.l !== undefined) {
            return executeHTTPRequest({
                method: 'GET',
                url: apiUrl + 'token?link=' + encodeURIComponent(ActualFlare.vars.l),
                headers: header
            }, function (err, response) {

                if (err) {
                    return callback();
                }

                if (response && response.body && response.body.tracking_token) {
                    trackingToken = response.body.tracking_token;
                }

                return callback();
            });
        }
        else {
            return callback();
        }
    }

    function identifyFromUrl(callback) {

        if (ActualFlare.vars.ce !== undefined && ActualFlare.vars.ce !== "") {
            return self.identify(unescape(ActualFlare.vars.ce), callback);
        }
        else if (ActualFlare.vars.cee !== undefined && ActualFlare.vars.cee !== "") {
            return self.identify(decodeBase64(unescape(ActualFlare.vars.cee)), callback);
        }

        return callback();
    }

    this.identify = function identify(email, callback) {

        var contact = {
            email: decode(email)
        };

        return executeHTTPRequest({
            method: 'POST',
            url: apiUrl + 'contacts',
            headers: header,
            body: contact
        }, function (err, response) {

            if (err) {
                return callback();
            }

            var device = {
                contact: response.body.id
            };

            return executeHTTPRequest({
                method: 'PUT',
                url: apiUrl + 'devices/' + deviceId,
                headers: header,
                body: device
            }, callback);
        });
    };

    // Because < IE 10
    function decodeBase64(s) {
        var e = {}, i, b = 0, c, x, l = 0, a, r = '', w = String.fromCharCode, L = s.length;
        var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        for (i = 0; i < 64; i++) { e[A.charAt(i)] = i; }
        for (x = 0; x < L; x++) {
            c = e[s.charAt(x)]; b = (b << 6) + c; l += 6;
            while (l >= 8) { ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a)); }
        }
        return r;
    };

    // Based on https://github.com/sindresorhus/prepend-http/blob/040579fb1271df6232dd96a7600c9efb1510eb47/index.js
    function sanitizeURL(url) {

        url = decode(url.trim());

        // Ignore custom protocols
        if (/^(?!localhost)\w+:/.test(url)) {
            return url;
        }

        // Replace relative stuff like `./test.com`
        if (/^\.*\/+/.test(url)) {
            return url.replace(/^\.*\/+/, 'http://');
        }

        return url.replace(/^(?!(?:\w+:)?\/\/)/, 'http://');
    }

    function decode(string) {

        var decoded;
        // We have old urls encoded using escape which breaks when using multi byte characters like "è"
        // If the url does not have special chars, `decodeURIComponent` will work
        // If it has something like "è" it will throw so then we fall back to unescape
        try {
            decoded = decodeURIComponent(string);
        }
        catch (_) {
            decoded = unescape(string);
        }

        return decoded;
    }
}